module.exports = __webpack_public_path__ + "img/teacher10.8c260965.webp";